import { ServiceItem } from '@/components/product/interface';
import UKDrawer from '@/components/UKDrawer';
import ServiceDetail from './serviceDetail';

interface ServiceDetailDrawProps {
  detailConfig: {
    isOpen?: boolean;
    serviceItem?: ServiceItem;
  };
  drawerChange: () => void;
  mainskuid: string;
}

const ServiceDetailDraw = ({ detailConfig, drawerChange, mainskuid }: ServiceDetailDrawProps) => {
  const { name } = detailConfig?.serviceItem || {};

  return (
    <UKDrawer
      width={430}
      openDrawer={detailConfig?.isOpen || false}
      handleClose={drawerChange}
      title={name}
    >
      <ServiceDetail serviceItemId={detailConfig?.serviceItem?.skuId} mainskuid={mainskuid} />
    </UKDrawer>
  );
};

export default ServiceDetailDraw;
